import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';


@customElement('cover-table')
export class CoverTable extends connect(store)(LitElement) {

	static styles = css`
	.coverTableItem {
		display: flex;
    	justify-content: space-between;
    	width: 100%;
		padding-top: var(--specsheet-medium-gap);
	}

	.title {
		width: 35%;
		font: var(--font-summary-paragraph);
		padding-top: var(--sections-gap);
		color: #939393;
	}

	.content {
		width: 65%;
	}

	  @media print {
		.coverTableItem {
			display: flex;
			justify-content: space-between;
			width: 100%;
			padding-top: var(--specsheet-small-gap);
		}

		.title {
			font: var(--font-specsheet-print-light);
			color: #939393;
			padding-top: var(--sections-gap);
		}
	  }
	`;
	@property({type: String})
	key = '';

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.lang = state.status.lang;
		this.translations = state.productData.translations;
		this.decisions = state.decisions.data;
		this.productData = state.productData.productData;
		this.debug = state.status.debug;
		this.title = this.getAttribute('title') || '';
	}


	static properties = {
		condition: { type: Function },
		title: { type: String },
	  };

	render() {
		return html`
		${this.condition === undefined || this.condition.trim() !== '' ? html`
		<div class="coverTableItem">
    		<div class="title">${this.title}</div>
    		<div class="content">
    		   <slot></slot>
    		</div>
			</div>
		</div>
			` : ''}

		`;
	}
}
